import React from "react";
import {useAxiosSetup, getAppName} from "./Api";
import {useAppData} from "./AppDataContext";

function ConfigurationHandler(props) {

    const [configurationLoaded, setConfigurationLoaded] = React.useState(false);
    const api = useAxiosSetup();
    const {appData, updateAppData} = useAppData();


    React.useEffect(() => {
        api.get('/configuration/get_single/').then((response) => {
            const root = document.documentElement;
            const data = response.data.serialized_data
            appData.buildInfo = JSON.stringify(response.data.build_meta)
            appData.userVersionUpToDate = JSON.stringify(response.data.user_up_to_date) === 'true'
            updateAppData(appData);
            root.style.setProperty('--colorA', data.Config.Colors.ColorA);
            root.style.setProperty('--colorB', data.Config.Colors.ColorB);
            root.style.setProperty('--colorC', data.Config.Colors.ColorC);
            root.style.setProperty('--colorD', data.Config.Colors.ColorD);
            root.style.setProperty('--color-rgb-A', hexToRgb(data.Config.Colors.ColorA));
            root.style.setProperty('--color-rgb-B', hexToRgb(data.Config.Colors.ColorB));
            root.style.setProperty('--color-rgb-C', hexToRgb(data.Config.Colors.ColorC));
            root.style.setProperty('--color-rgb-D', hexToRgb(data.Config.Colors.ColorD));
            setConfigurationLoaded(true)
        }).catch(() => {
            setConfigurationLoaded(true)
        })
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function hexToRgb(hex) {
        // Ensure the hex color is valid
        if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            throw new Error('Invalid hex color');
        }

        let r, g, b;

        if (hex.length === 4) { // Handle short form: #RGB
            r = parseInt(hex.charAt(1) + hex.charAt(1), 16);
            g = parseInt(hex.charAt(2) + hex.charAt(2), 16);
            b = parseInt(hex.charAt(3) + hex.charAt(3), 16);
        } else { // Handle full form: #RRGGBB
            r = parseInt(hex.substring(1, 3), 16);
            g = parseInt(hex.substring(3, 5), 16);
            b = parseInt(hex.substring(5, 7), 16);
        }
        return `${r}, ${g}, ${b}`;
    }

    return (
        <>
            {configurationLoaded && props.children}
        </>
    )
}

export default ConfigurationHandler
